import React, { Component } from "react";

import ChristianityExploredImg from "../../assets/images/new_here/ChristianityExplored.jpg";

class ChristianityExplored extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Christianity Explored</h1>
					</div>
				</header>
				<section className="container">
					<img src={ChristianityExploredImg} style={{ float: "right" }} alt="One life. What's it all about?" />
					<p>
						You may still not know who Jesus is or where you stand with him. If that’s you, we’d love to invite you to
						one of our ‘Christianity Explored’ courses. ‘Christianity Explored’ is an informal, seven-week discussion
						group that examines the life and claims of Jesus from one of the original biographies of his life, the
						Gospel of Mark. You will not be asked to read aloud, sing, pray or do anything else you don’t want to do,
						and it assumes no prior knowledge about Christianity.
						<br />
						<br />
						If you want information about the course generally, please go to the Christianity Explored website:{" "}
						<a href="http://www.christianityexplored.org" target="_blank" rel="noopener noreferrer">
							http://www.christianityexplored.org
						</a>
						<br />
						<br />
						If you would like to join a Christianity Explored course at CRCK, please contact the church office: (03 6229
						2268) or <a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
					</p>
				</section>
			</section>
		);
	}
}

export default ChristianityExplored;
